<template>
    <div class="contact">
        <div class="icon">
            <img src="../../../assets/images/xh_code.png" alt="">
        </div>
        <div class="wrap">
            <p class="part">
                <span class="partLeft">会址</span>       
                <span class="partRight">济南奥体中心体育场二楼236入口</span>
            </p>
            <p class="part">
                <span class="partLeft">秘书处联络人</span>       
                <span class="partRight">金石</span>
            </p>
            <p class="part">
                <span class="partLeft">联系电话</span>       
                <span class="partRight">0531-86404777 186 0531 8829</span>
            </p>
            <p class="part">
                <span class="partLeft">邮箱</span>       
                <span class="partRight">cnqilu@126.com</span>
            </p>
            <p class="part">
                <span class="partLeft">微信平台</span>       
                <span class="partRight">齐鲁文创（ID：cnqilu）</span>
            </p>
        </div>
        <div  class = "allmap" id = "allmap"></div>     
    </div>
</template>

<script>
export default {
    name: 'Contact',
    data() {
        return {
            
        }
    },
    mounted() {
        this.getMap()
    },
    methods: {
        getMap(){
            // 百度地图API功能
            var map = new BMap.Map("allmap");    // 创建Map实例
            var point = new BMap.Point(117.1231730000,36.6646360000);   // 创建点坐标
            map.centerAndZoom(new BMap.Point(117.1231730000,36.6646360000), 14);  // 初始化地图,设置中心点坐标和地图级别
            //添加地图类型控件
            map.addControl(new BMap.MapTypeControl({
            mapTypes:[
                BMAP_NORMAL_MAP,
                BMAP_HYBRID_MAP
            ]}));	  
            map.setCurrentCity("济南");          // 设置地图显示的城市 此项是必须设置的
            map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
            map.addControl(new BMap.NavigationControl());   //平移缩放控件
            var marker = new BMap.Marker(point);        // 创建标注    
            map.addOverlay(marker);                     // 将标注添加到地图中 
            marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
        }
    },
}
</script>

<style scoped>
.contact{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
    padding: .25rem;
}    
.icon{
    width: 3.5rem;
    height: 3.5rem;
    border: .02rem dashed #ccc;
    margin: .3rem auto;
}
.wrap{
    margin: .5rem 0;
    padding: 0 .3rem;
}
.part{
    display: flex;
    font-size: .25rem;
    line-height: .75rem;
}
.part .partLeft{
    width: 1.9rem;
    color: #999;
    font-weight: bold;
}
.part .partRight{
    color: #333;
}
.allmap{
    width: 100%;
    height: 3.9rem;
}
</style>